import styled from 'styled-components';
export const LinkText = styled.span `
  border-bottom: 1px solid transparent;
`;
